import RestApiCall from "interceptor/aeh";
import Environment from "services/environment";
const env = Environment.getEnv();

export const verifyAndFetchFeedbackConfig = (data) => {
    const apiPayload = {
        method: "POST",
        url: "user/v1/feedback/verify",
        baseURL: env.feedbackUnauthBaseUrl,
        config: { ivUser: env.ivUser },
        data,
    }
    return RestApiCall.api(apiPayload);
}

export const fetchFeedbackConfig = (data) => {
    const apiPayload = {
        method: "POST",
        url: "user/v1/feedback/link",
        baseURL: env.feedbackUnauthBaseUrl,
        config: { ivUser: env.ivUser },
        data,
    }
    return RestApiCall.api(apiPayload);
}

export const saveUserFeedback = (data) => {
    const apiPayload = {
        method: "POST",
        url: "user/v3/feedback/rating",
        baseURL: env.feedbackUnauthBaseUrl,
        config: { ivUser: env.ivUser },
        data,
    }
    return RestApiCall.api(apiPayload);
}